<main class="main">
  <div class="content">
    <div class="login-center">
      <div class="login-image">
        <img alt="logo bal" src="../../assets/logo_bal_mini.png" style="width: 125px; height: 125px;" />
        <span class="registered">&#xae;</span>
      </div>
      <p></p>
      <mat-card class="login-card">
        <mat-card-header>
          <mat-card-title>Herramienta de Gestión de la Presidencia</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>&nbsp;</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-flat-button color="primary" style="background: #315290;" (click)="login()">
            INICIAR SESIÓN
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</main>
